///<reference path="./dev-types.d.ts"/>
"use strict";
var persistState = require('redux-localstorage');
var configure_logger_1 = require('./configure-logger');
var baseEnhancers = [];
exports.middleware = __DEV__ ? [configure_logger_1.default] : [];
exports.enhancers = __DEV__ && window.devToolsExtension ?
    baseEnhancers.concat([window.devToolsExtension()]) :
    baseEnhancers;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSx1Q0FBdUM7O0FBR3ZDLElBQU0sWUFBWSxHQUFHLE9BQU8sQ0FBQyxvQkFBb0IsQ0FBQyxDQUFDO0FBQ25ELGlDQUFtQixvQkFBb0IsQ0FBQyxDQUFBO0FBRXhDLElBQU0sYUFBYSxHQUFHLEVBQUUsQ0FBQztBQUVaLGtCQUFVLEdBQUcsT0FBTyxHQUFHLENBQUUsMEJBQU0sQ0FBRSxHQUFHLEVBQUUsQ0FBQztBQUV2QyxpQkFBUyxHQUFHLE9BQU8sSUFBSSxNQUFNLENBQUMsaUJBQWlCO0lBQ3JELGFBQWEsU0FBRSxNQUFNLENBQUMsaUJBQWlCLEVBQUUsRUFBRTtJQUNoRCxhQUFhLENBQUMifQ==


/*****************
 ** WEBPACK FOOTER
 ** ./src/store/index.ts
 ** module id = 972
 ** module chunks = 1
 **/